import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToHashTarget } from '../lib/scrollToHashTarget.js';

const HASH_SCROLL_RETRY_LIMIT = 10;
const HASH_SCROLL_RETRY_DELAY_MS = 50;

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    let timeoutId = null;
    let attempts = 0;

    const handleScroll = () => {
      attempts += 1;

      if (hash && scrollToHashTarget(hash)) {
        return;
      }

      if (hash && attempts < HASH_SCROLL_RETRY_LIMIT) {
        timeoutId = window.setTimeout(handleScroll, HASH_SCROLL_RETRY_DELAY_MS);
        return;
      }

      window.scrollTo(0, 0);
    };

    handleScroll();

    return () => {
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [pathname, hash]);

  return null;
}
